const PresetAxis: { [key: string]: any } = {
  axial: [1, 0, 0, 0, 1, 0],
  coronal: [1, 0, 0, 0, 0, -1],
  sagittal: [0, 1, 0, 0, 0, -1],
};

const getPresetOrientation = (name: string) => {
  if (Object.hasOwnProperty(name) === true) {
    return PresetAxis[name];
  }
  return null;
};

export { getPresetOrientation };
